/**
 * Copyright © 2026 Adnuntius AS.
 *
 * Cycle-safe DI tokens for session profile services. Import these instead of
 * LocalUserProfile / LocalNetworkProfile from network resources and AdnLogService
 * — those create ES-module cycles with the profile classes.
 */
import {InjectionToken} from '@angular/core';

export const LOCAL_USER_PROFILE = new InjectionToken<any>('LocalUserProfile');
export const LOCAL_NETWORK_PROFILE = new InjectionToken<any>('LocalNetworkProfile');
